import styled from 'styled-components';

export default styled.section`
  padding: 2rem 0 0;

  thead {
    @media (max-width: ${props => props.theme.breakpoints.desktop}) {
      display: none;
    }

    th {
      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        border-bottom: solid 1px ${props => props.theme.colors.grey5};
      }
    }

    h2 {
      margin: 0;
    }
  }

  tbody {
    tr {
      @media (max-width: ${props => props.theme.breakpoints.desktop}) {
        display: flex;
        flex-direction: column;
      }
    }

    td {
      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        border-bottom: solid 1px ${props => props.theme.colors.grey5};

        &:first-child {
          min-width: 130px;
        }

        &:nth-child(2) {
          padding-right: 1rem;
        }
      }

      @media (max-width: ${props => props.theme.breakpoints.desktop}) {
        &:first-child {
          padding-top: 1.5rem;
        }

        &:last-child {
          padding-bottom: 1.5rem;
          border-bottom: solid 1px ${props => props.theme.colors.grey5};
        }
      }
    }

    p {
      margin: 0;
    }
  }

  td,
  th {
    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      padding: 1rem 0.5rem;

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }

    &:first-child,
    &:nth-child(2) {
      p {
        line-height: 1.2em;
      }
    }

    p {
      &.type-h6 {
        margin-top: 0.5rem;
        margin-bottom: 0.25rem;
      }
    }
  }
`;
